'use client'
import { useEffect } from 'react'

import { Modal, ModalBody, ModalContent, ModalFooter, useDisclosure } from '@nextui-org/modal'
import { Button } from '@nextui-org/button'

import { useMarkUserVisitedMutation } from '@/redux/api/tutorial'
import { useAppSelector } from '@/hooks'
import useIsMobile from '@/hooks/useIsMobile'

const ModalWelcome = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const point = useAppSelector((state) => state.root.auth.pointInviteCode) // Lấy id của user
  const isMobile = useIsMobile()
  useEffect(() => {
    onOpen()
  }, [])

  const [markUserVisited, { isLoading }] = useMarkUserVisitedMutation()
  const handleVisited = async () => {
    try {
      await markUserVisited()
    } catch (error) {
    } finally {
      onClose()
    }
  }

  return (
    <Modal
      placement="center"
      hideCloseButton={true}
      className="bg-ss-purple-950"
      size="sm"
      backdrop={'blur'}
      isOpen={isOpen}
      onClose={onClose}
    >
      <ModalContent className="md:px-8 py-10">
        <ModalBody className="text-center">
          <h3 className="text-[64px]">🎉</h3>
          {!!point && (
            <p className="text-2xl font-medium text-white">
              {' '}
              You got <span className="text-[#FAC515]">{point} SSP</span> from referral program.{' '}
            </p>
          )}

          <p className="text-base text-ss-grayscale-300">
            Welcome to Sightsea. <br /> Take a look around, explore all we have to offer. Enjoy your journey!
          </p>
        </ModalBody>
        <ModalFooter>
          <Button
            isLoading={isLoading}
            size={isMobile ? 'md' : 'lg'}
            className="flex w-full items-center gap-1 bg-btn-gradient text-lg font-medium text-white"
            color="danger"
            variant="light"
            onPress={handleVisited}
          >
            <span>Join Our Community </span>
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default ModalWelcome
